'use strict';

const { convertStrToBool } = require('../utils/commonHelper');

/**
 * change favorite button
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function changeFavoriteButton(data, button) {
    $.spinner().stop();
    button.removeAttr('disabled');
    var url = button.data('action-url');
    if (data.success) {
        var wasFavorite = convertStrToBool(button.attr('data-is-favorite'));
        if (wasFavorite) {
            // 登録機能に変更
            url = url.replace('Wishlist-RemoveProduct', 'Wishlist-AddProduct');
            button.attr('data-action-url', url);
            button.attr('data-action', 'Wishlist-AddProduct');
        } else {
            // 登録解除機能に変更
            url = url.replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct');
            button.attr('data-action-url', url);
            button.attr('data-action', 'Wishlist-RemoveProduct');
        }
        button.attr('data-is-favorite', !wasFavorite);
        button.toggleClass('is-active');
    } else {
        // エラーメッセージの表示
        button.removeAttr('disabled');
    }
}

/**
 * Initialize favorite button status via AJAX
 * @param {Object} button - button element to initialize
 */
function initializeFavoriteButton(button) {
    var pid = button.attr('data-pid');
    var url = button.data('action-url');
    var checkUrl = button.data('check-favorite-url');

    if (!pid || !url || !checkUrl) {
        return;
    }

    $.ajax({
        url: checkUrl,
        type: 'get',
        data: { pid: pid },
        dataType: 'json',
        success: function (data) {
            var isFavorite = data.isFavorite;

            // Update button attributes based on server response
            button.attr('data-is-favorite', isFavorite);

            if (isFavorite) {
                // Set to remove mode
                url = url.replace('Wishlist-AddProduct', 'Wishlist-RemoveProduct');
                button.attr('data-action-url', url);
                button.attr('data-action', 'Wishlist-RemoveProduct');
                button.addClass('is-active');
            } else {
                // Set to add mode
                url = url.replace('Wishlist-RemoveProduct', 'Wishlist-AddProduct');
                button.attr('data-action-url', url);
                button.attr('data-action', 'Wishlist-AddProduct');
                button.removeClass('is-active');
            }
        },
        error: function (err) {
            // If error occurs, keep the default state
        }
    });
}

module.exports = {
    changeFavoriteButton: changeFavoriteButton,
    initializeFavoriteButton: initializeFavoriteButton
};